<template>
  <div>
    <!-- Modal -->
    
    <Modal name="full-slider" width="100%" height="100%" class="modal-modal open-470" >

        <div class="mt-3 mb-3 px-4 text-right">
          <button @click="hideModal" class="close text-xl text-teal-400 hover:text-teal-300 font-semibold">
            <i class="fas fa-times text-2xl"></i>
          </button>
          <div class="modal-content unclickable unscrollable">
          <ModalImage :slides="slides" :pindex="pindex"/>
        </div>
        </div>

    </Modal>

    <!-- /Modal -->

    <!-- Main Slider -->
    <slick
      id="slick1"
      :options="slickOptions"
      ref="slickSetting1"
      v-if="slides.length"
      class="main"
    >
      <div v-for="(slide, index) in slides" :key="index" class="slide" :class="`slide--${index}`" style="display: inline-block; vertical-align: top;">
        <span @click="showPhoto(index)">
          <img :src="slide" class="grid-img" />
        </span>
      </div>
    </slick>
    <!-- /Main Slider -->

    <!-- Thumb Slider -->
    <slick
      id="slick2"
      :options="slickOptions2"
      ref="slickSetting2"
      v-if="slides.length"
      class="thumbnails hide-450"
    >
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="slide slide--thumbniail"
        :class="`slide--${index}`"
      >
        <img :src="slide" class="thumb-img" />
      </div>
    </slick>
    <!-- /Thumb Slider -->
  </div>
</template>

<script>
import Slick from "vue-slick";
import axios from "axios";
import ModalImage from "./ModalImage";

export default {
  components: {
    ModalImage,
    Slick,
  },
  data() {
    return {
      productId: this.$route.params.id,
      slides: [],
      pindex: 0,
      hooperSettings1: {
        transition: 800,
      },
      hooperSettings: {
        itemsToShow: 8,
        // centerMode: true,
      },
    };
  },

  computed: {
    getProductId() {
      return this.productId;
    },
    slickOptions() {
      return {
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: true,
        arrows: false,
        fade: true,
        // adaptiveHeight: true,
        asNavFor: "#slick2",
        responsive: [
          {
            breakpoint: 320,
            options: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 360,
            options: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 375,
            options: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
            // settings: "unslick"
          },
        ],
      };
    },
    slickOptions2() {
      return {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        // navButtons: true,
        autoplay: false,
        // speed: 2000,
        infinite: true,
        // cssEase: "linear",
        focusOnSelect: true,
        asNavFor: "#slick1",
        // adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 320,
            options: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 360,
            options: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 375,
            options: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
            // settings: "unslick"
          },
        ],
      };
    },
  },
  created() {
    this.getSlides();
  },
  methods: {
    showPhoto(index){
      this.pindex = index;
      this.show();
    },
    show() {
  this.$modal.show("full-slider");
  document.body.style.overflow = "hidden";
},

hideModal() {
    this.$modal.hide("full-slider");
    document.body.style.overflow = "auto";
  },
    changeBigImage() {
      this.$refs.hooper.slideTo(4);
    },
    getSlides() {
      axios
        .get(`${process.env.VUE_APP_API}/product/${this.productId}`)
        .then((response) => {
          this.slides = response.data.data.product_shop.product.images;
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style scoped>


.main {
  margin-bottom: 30px;
}

@media(max-width:470px){
  .v--modal-overlay .v--modal-box{
    position: static !important;
  }
  .hide-450{
    display: none;
  }

  .modal-content.unclickable {
  pointer-events: none;
}

.v--modal{
  top: 0 !important;
}


}

@media(min-width:415px) and (max-width:450px){
  .v--modal-overlay .v--modal-box{
    position: static !important;
  }
  .slick-400{
    display: none;
  }
  .v--modal{
    top:0% !important;
    width:96.5% !important;
  }

  .thumbnails {
  margin: 5px;
  width: 100% !important;
}
.slick-prev{
  left:-30px !important;
}

.slick-next{
  left:-58px !important;
}

.grid-img{
  width:90%;
  padding-right:10px !important;
}

}

.thumbnails {
  margin: 0 -5px;
  width: calc(100% + 10px);
}

.agile__nav-button {
  background: transparent;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 24px;
  transition-duration: 0.3s;
}


/* .thumbnails .agile__nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.thumbnails .agile__nav-button--prev {
  left: -45px;
}

.thumbnails .agile__nav-button--next {
  right: -45px;
} */

.agile__nav-button:hover {
  color: #888;
}

.agile__dot {
  margin: 0 10px;
}

.agile__dot button {
  background-color: #eee;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  transition-duration: 0.3s;
  width: 10px;
}

.agile__dot--current button,
.agile__dot:hover button {
  background-color: #888;
}

.slide {
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  height: 450px;
  justify-content: center;
}

.slide--thumbniail {
  cursor: pointer;
  height: 100px;
  padding: 0 5px;
  transition: opacity 0.3s;
}

.slide--thumbniail:hover {
  opacity: 0.75;
}

.slide img {
  height: 100%;
  object-fit: cover;
  object-position: center;
}



.slide .grid-img {
  padding: 20px;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
}

.main-full {
  margin: 10px;
}

.main-modal {
  height: auto;
}

.image-magnifier.ml-5 {
  width: 40%;
}

@media(max-width:470px){

  .slide img {
    height: 50%;
  object-fit: cover;
  object-position: center;
}
.slide {
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  height: 100%;
  justify-content: center;
}
.main{
  margin-bottom: 0;
}
}

@media(max-width:450px){
  .close{
    position: absolute;
    right:2% !important;
    top: 15%;
  z-index: 1000;
  }
}

.close{
  position: absolute;
  right: 27%;
  z-index: 1000;
}

@media (max-width: 320px) {
  .main {
    width: 300px;
  }
  .thumbnails {
    width: 300px;
  }
  .slide .grid-img {
    padding: 0px;
    object-fit: scale-down;
  }
}

@media (max-width: 360px) {
  .main {
    width: 300px;
  }
  .thumbnails {
    width: 300px;
  }
  .slide .grid-img {
    padding: 0px;
    /* object-fit: scale-down; */
  }
}

@media (max-width: 375px) {
  .main {
    width: 300px;
  }
  .thumbnails {
    width: 300px;
  }
  .slide .grid-img {
    padding: 0px;
    /* object-fit: scale-down; */
  }
}

@media (max-width: 411px) {
  .main {
    width: 340px;
  }
  .thumbnails {
    width: 340px;
  }
  .slide .grid-img {
    margin: auto;
    padding: 0px;
    object-fit: scale-down;
  }
}

@media (max-width: 450px) {
  .main {
    /* width: 450px; */
    width: 100%;
  }
  .thumbnails {
    margin: 5px;
    width: 451px;
  }
  .slide .grid-img {
    padding: 0px;
    object-fit: scale-down;
  }
}

@media (max-width: 414px) {
  .main {
    width: 345px;
  }
  .thumbnails {
    margin: 5px;
    width: 345px;
  }
  .slide .grid-img {
    padding: 0px;
    object-fit: scale-down;
  }
}
</style>

<style>
  button.slick-prev:before, button.slick-next:before {
      color: #4fd1c5 !important;
      font-size: 30px;
}
button.slick-next:before{
  margin-left: -300%;
}
</style>
